import OsqueryTableSnapshot from './OsqueryTableSnapshot'

export default OsqueryTableSnapshot
